@if (state.show) {
  <div class="vw-100 vh-100 position-fixed top-0 start-0 d-flex align-items-center justify-content-center spinner-container" >
    <div class="p-4 d-flex flex-column align-items-center">
      <div class="d-flex gap-2">
        <div class="spinner-border text-{{ state.color }}" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      @if (state.message) {
        <div class="text-center mt-3 user-select-none text-white">
          {{ state.message }}
        </div>
      }
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
}
